import "./src/layout/global.css"

// Don't update scroll on page change
export function shouldUpdateScroll() {
  return false
}
